import React from 'react';
import { StyleSheet } from 'react-native';

import { PaymentElement } from '@stripe/react-stripe-js';

import { useA11ySelector } from '@sg/a11y-helpers';
import { theme, useResponsive } from '@sg/garnish';

import { GiftCardCheckoutFormGroup } from '../../components/GiftCardCheckoutFormGroup';

// ─────────────────────────────────────────────────────────────────────────────

export const GiftCardCheckoutPaymentElement = (_props: GiftCardCheckoutPaymentElementProps) => {
  const { match } = useResponsive();

  const a11ySelector = useA11ySelector('gift-cards.customization.payment-option');

  return (
    <GiftCardCheckoutFormGroup.Container
      {...a11ySelector.props}
      style={match([null, styles.containerSM])}
    >
      <PaymentElement />
    </GiftCardCheckoutFormGroup.Container>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  containerSM: {
    borderBottomStartRadius: theme.radius.large,
    borderBottomEndRadius: theme.radius.large,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type GiftCardCheckoutPaymentElementProps = {
  embeddedPaymentElementView: React.ReactNode;
};
